import React from "react";
import "./styles/datenschutz.css";
import { LOCATION } from "../config/location";
import { PageHead } from "../components/site/Blocks";

const Impressum = () => {
    return (
        <>
            <PageHead eyebrow="Rechtliches" title="Impressum" className="!pb-12" />
            <section className="sec pb-[140px]">
            <div className="legal">
                <p className=" mb-4">
                    Angaben gemäß § 5 TMG (Telemediengesetz)
                </p>

                <div className="mb-6">
                    <h2 className="text-lg font-semibold">
                        Kontakt
                    </h2>
                    <p >
                        Spyros Gkikas
                        <br />
                        Restaurant En Edem
                        <br />
                        {LOCATION.street}
                        <br />
                        76356 Weingarten
                        <br />
                        Deutschland
                    </p>
                    <p className=" mt-2">
                        Telefon: +49 7244 9469991
                        <br />
                        E-Mail:{" "}
                        <a
                            href="mailto:info@en-edem.de"
                            className="text-blue-500 hover:underline"
                        >
                            info@en-edem.de
                        </a>
                    </p>
                </div>

                <div className="mb-6">
                    <h2 className="text-lg font-semibold">
                        Umsatzsteuer
                    </h2>
                    <p >
                        Umsatzsteuer-Identifikationsnummer gemäß §27 a
                        Umsatzsteuergesetz:
                        <br />
                        DE343257150
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-semibold">
                        Aufsichtsbehörde
                    </h2>
                    <p >
                        Landratsamt Karlsruhe <br />
                        Beiertheimer Allee 2 <br />
                        76137 Karlsruhe <br />
                        <a
                            href="http://www.landkreis-karlsruhe.de"
                            className="text-blue-500 hover:underline"
                        >
                            http://www.landkreis-karlsruhe.de
                        </a>
                    </p>
                </div>
            </div>
            </section>
        </>
    );
};

export default Impressum;
